import { IGetDashboardControleDocumentosInformationUseCase } from "../../../presentation/useCases/read/get_dashboard_controle_documentos_information_use_case";
import { DashboardControleDocumentos } from "../../models/dashboard_controle_documentos";
import { IControleDocumentosRepository } from "../../repositories/controle_documentos_repository";

/**
 * GetDashboardControleDocumentosInformationUseCase
 */

export class GetDashboardControleDocumentosInformationUseCase
  implements IGetDashboardControleDocumentosInformationUseCase {
  constructor(private readonly repository: IControleDocumentosRepository) { }

  async getDashboardControleDocumentosInformation(
  ): Promise<DashboardControleDocumentos> {
    return await this.repository.getDashboardControleDocumentosInformation();
  }
}
